import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { pausedUploadsSelector, setUploadsResumedAction, useUploaderStore } from '@air/redux-uploader';

export const useResumeAllUploads = () => {
  const dispatch = useDispatch();
  const store = useUploaderStore();

  const resumeAllUploads = useCallback(() => {
    const pausedUploads = pausedUploadsSelector(store.getState());
    dispatch(setUploadsResumedAction({ uploadIds: pausedUploads.map(({ id }) => id) }));
  }, [dispatch, store]);

  return {
    resumeAllUploads,
  };
};
